import { getDate, getMonth, getYear,format as dateFNSFormat, addWeeks, addMonths } from 'date-fns';
import enLocale from 'date-fns/locale/en-GB';
import huLocale from 'date-fns/locale/hu';
import deLocale from 'date-fns/locale/de';
import i18n from '../i18n';
import { SUPPORTED_LANGUAGES } from './const';

export const localeMap = {
  en: enLocale,
  hu: huLocale,
  de: deLocale
};

export const getTomorrowDate = () => {
  let date = new Date();
  const tomorrowDate = date.getDate() + 1;
  date.setDate(tomorrowDate);
  return date;
};

export const formatDateString = date => {
  if (date) {
    return `${date.year}/${date.month}/${date.day}`;
  }
};

export const convertDateToModernCalendarFormat = date => ({
  day: getDate(date),
  month: getMonth(date) + 1, //Modern calendar starts months at 1 unlike JS which starts at 0
  year: getYear(date)
});

export const formatDate = (date, format = 'P', options) => {
  return dateFNSFormat(new Date(date), format, {
    locale: localeMap[i18n.language],
    ...options
  });
};

export const createNext2WeeksValue = () => {
  const now = new Date();

  return JSON.stringify({
    from: convertDateToModernCalendarFormat(now),
    to: convertDateToModernCalendarFormat(addWeeks(now, 2))
  });
};

export const getDateFormat = () => {
  return i18n.language ===  SUPPORTED_LANGUAGES.HU ? 'yyyy/MM/dd' : 'dd/MM/yyyy';
};

export const addMonthsToDate = (date, month) => addMonths(date, month);
